import styled, { css } from 'styled-components';
import type { ColorName } from 'styles/config/colors';
import themeColors from 'styles/config/colors';
import themeSpacing from 'styles/config/spacing';

interface OpenableProps {
  $isOpen: boolean;
  $fullWidth?: boolean;
}

const OPEN_WIDTH = 400;

export const Wrapper = styled.div<Pick<OpenableProps, '$fullWidth'>>`
  display: flex;
  flex-direction: column;

  ${({ $fullWidth }) =>
    $fullWidth &&
    css`
      width: 100%;
    `}
`;

export const SearchFieldWrapper = styled.div<OpenableProps>`
  display: flex;
  align-items: center;

  width: ${themeSpacing.sm4};
  height: ${themeSpacing.sm4};

  transition: width 0.2s ease-in-out;
  ${p =>
    p.$isOpen &&
    css`
      width: ${p.$fullWidth ? '100%' : `${OPEN_WIDTH}px`};
    `};
`;

export const Underline = styled.div<OpenableProps & { $color: ColorName }>`
  width: 0;
  border-top: 1px ${({ $color }) => themeColors[$color]} solid;
  transition: width 0.2s ease-in-out;
  ${p =>
    p.$isOpen &&
    css`
      width: ${p.$fullWidth ? '100%' : `${OPEN_WIDTH}px`};
    `};
`;

export const IconWrapper = styled.div`
  display: flex;
  margin: ${themeSpacing.xs2};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-left: 0;
  }
`;

export const InputWrapper = styled.div<OpenableProps>`
  display: flex;
  justify-content: space-between;

  width: 100%;

  opacity: 0;

  transition: opacity 0.2s ease-in-out;

  ${p =>
    p.$isOpen &&
    css`
      opacity: 1;
    `}

  & input {
    font-size: ${p => p.theme.text.size.body.regular};
    font-weight: ${p => p.theme.text.weight.semibold};
  }
`;
